import React from 'react';
import range from 'lodash/range';
import { MgtPersonCard, Person, PersonCardInteraction } from '@microsoft/mgt-react';
import { UsersTooltip } from '../../../../shared/components/TicketDetailInfo/UsersTooltip';
import { UserAvatar } from '../../../../shared/components/UserAvatar';
import { SpeakerPersonIcon } from '@fluentui/react-icons-northstar';
import { useTranslation } from 'react-i18next';

export interface GroupUsersIconProps {
  usersList: { PlatformUserId: number, PlatformUser?: PlatformUser }[];
  maxLength: number;
  isListing?: boolean;
  title?: string;
}

export const GroupUsersIcon = ({ usersList, maxLength, isListing = false, title }: GroupUsersIconProps) => {
  const { t } = useTranslation();

  //Disable Mail section to not require Mail.ReadBasic in Tikit scopes
  MgtPersonCard.config.sections.mailMessages = false;
  
  maxLength = maxLength + 1;
  return (
    <>
      {range(0, Math.min(usersList?.length, maxLength)).map(i => {
          if ((i+1) === maxLength) {
            const list = usersList.slice(i, usersList.length).map(u => u.PlatformUser);
            return (<UsersTooltip ticketCollaborator={list} isPluseShow={true} position={'top'} title={title ?? t('side-nav.users')} />);
          } else {
            const user = usersList[i].PlatformUser;
            return (
              <span className={`mr-1`}>
                {!isListing && <Person personDetails={{ displayName: user?.FullName, mail: user?.Email, id: user?.AadObjectId, userPrincipalName: user?.UserName }} fetchImage avatarSize="auto" personCardInteraction={PersonCardInteraction.hover} />}
                {isListing && user && <UserAvatar {...{
                    idOrUpn: user?.AadObjectId ? user?.AadObjectId : user?.UserName,
                    avatarProps: { name: user?.FullName, size: 'smaller', className: 'cui-ml-2' },
                  }} />}
                {isListing && !user && <SpeakerPersonIcon size="large" style={{ color: '#8f90a6' }} variables={{ largeSize: '24px' }} />}
              </span>
            );
          }
        })}
    </>
  );
};
